module.exports = __webpack_public_path__ + "img/GitHub.bbc8bac.svg";